
import React from 'react'
import { Browse } from 'modules/index/browse'

export default () => {
    return <Browse injectStyle={`padding-top: 25px;`} />
}